import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "cookie_consent"
const EXPIRATION_DAYS = 365

export default class extends Controller {
  static targets = ["banner"]
  static values = { secure: Boolean }

  connect() {
    if (!this.hasConsent()) {
      this.showBanner()
    }
  }

  acceptAll() {
    this.#saveConsent({ marketing: true, analytics: true })
  }

  declineAll() {
    this.#saveConsent({ marketing: false, analytics: false })
  }

  #saveConsent(permissions) {
    const consent = {
      essential: true,
      ...permissions
    }
    this.setCookie(consent)
    this.hideBanner()
    window.location.reload()
  }

  hasConsent() {
    return document.cookie.split(';').some((item) => item.trim().startsWith(`${COOKIE_NAME}=`))
  }

  setCookie(value) {
    const date = new Date()
    date.setTime(date.getTime() + (EXPIRATION_DAYS * 24 * 60 * 60 * 1000))
    const expires = "expires=" + date.toUTCString()
    const jsonValue = JSON.stringify(value)
    const secure = this.secureValue ? ";Secure" : ""
    document.cookie = `${COOKIE_NAME}=${jsonValue};${expires};path=/;SameSite=Lax${secure}`
  }

  showBanner() {
    this.bannerTarget.classList.remove("hidden")
  }

  hideBanner() {
    this.bannerTarget.classList.add("hidden")
  }
}
